<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<p-accordion *ngIf="!carInformacionInicial" id="accordion" [multiple]="true">
  <p-accordionTab
    header="{{ 'SARLAFT.LBL_DATOSGENERALES' | translate }}"
    [selected]="true"
  >
    <form
      [formGroup]="formulario"
      (ngSubmit)="onSubmit()"
      novalidate
      id="fVariables"
      name="fVariables"
    >
      <div class="grid form-group" *ngIf="listaVariables.length > 0">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form" *ngIf="!verDetalle && !variable?.codigoVariableSarlaft">
            <label>* {{ "SARLAFT.LBL_VARIABLE" | translate }}</label>
            <p-dropdown disableTab
              id="variable"
              name="variable"
              formControlName="variable"
              [options]="listaVariables"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              optionValue="value"
              optionLabel="label"
            ></p-dropdown>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submitted && f.variable.invalid"
            >
              {{ "SARLAFT.LBL_VARIABLE" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
          <div class="div-form" *ngIf="variable?.codigoVariableSarlaft">
            <label>{{ "SARLAFT.LBL_VARIABLE" | translate }}:</label>
            <label class="falso-combo-texto">{{
              variable.variableSarlaft
            }}</label>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form" *ngIf="!verDetalle">
            <label>* {{ "SARLAFT.LBL_PESO" | translate }}</label>
            <input
              numero-entero-reactive
              appTexto
              pInputText
              type="text"
              id="peso"
              name="peso"
              autocomplete="off"
              formControlName="peso"
              maxlength="5"
              [sinComa]="true"
              [sinEspacio]="true"
              [sinCaracteres]="true"
              [sinPunto]="true"
              [sinLetras]="true"
            />
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submitted && f.peso.invalid"
            >
              {{ "SARLAFT.LBL_PESO" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
          <div class="div-form" *ngIf="verDetalle">
            <label>{{ "SARLAFT.LBL_PESO" | translate }}:</label>
            <label class="falso-combo-texto">{{ variable.peso }}</label>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form" *ngIf="!verDetalle">
            <label>* {{ "SARLAFT.LBL_VALORPORDEFECTO" | translate }}</label>
            <input
              numero-entero-reactive
              appTexto
              pInputText
              type="text"
              id="valorDefecto"
              name="valorDefecto"
              autocomplete="off"
              formControlName="valorDefecto"
              maxlength="5"
              [sinComa]="true"
              [sinEspacio]="true"
              [sinCaracteres]="true"
              [sinPunto]="true"
              [sinLetras]="true"
            />
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submitted && f.valorDefecto.invalid"
            >
              {{ "SARLAFT.LBL_VALORPORDEFECTO" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
          <div class="div-form" *ngIf="verDetalle">
            <label>{{ "SARLAFT.LBL_VALORPORDEFECTO" | translate }}:</label>
            <label class="falso-combo-texto">{{ variable.valorDefecto }}</label>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form" *ngIf="!verDetalle">
            <label>{{ "SARLAFT.LBL_DESCRIPCION" | translate }}</label>
            <textarea
              pInputTextarea
              id="descripcion"
              name="descripcion"
              formControlName="descripcion"
              [maxlength]="200"
              rows="4"
              style="resize: none"
            ></textarea>
          </div>
          <div class="div-form" *ngIf="verDetalle">
            <label>{{ "SARLAFT.LBL_DESCRIPCION" | translate }}:</label>
            <label class="falso-combo-texto">{{ variable.descripcion }}</label>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <div
            class="div-form"
            style="height: 100%; display: flex; align-items: center"
          >
            <p-checkbox
              *ngIf="verDetalle"
              label="{{ 'SARLAFT.LBL_DETERMINANTE' | translate }}"
              id="indicadorDeterminante"
              name="nomindicadorDeterminante"
              formControlName="indicadorDeterminante"
              binary="true"
            ></p-checkbox>
            <p-checkbox
              *ngIf="!verDetalle"
              label="{{ 'SARLAFT.LBL_DETERMINANTE' | translate }}"
              id="indicadorDeterminante"
              name="nomindicadorDeterminante"
              formControlName="indicadorDeterminante"
              binary="true"
            ></p-checkbox>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <div
            class="div-form"
            style="height: 100%; display: flex; align-items: center"
          >
            <p-checkbox
              *ngIf="verDetalle"
              label="{{ 'SARLAFT.LBL_HABILITADO' | translate }}"
              id="indicadorHabilitado"
              name="nomindicadorHabilitado"
              formControlName="indicadorHabilitado"
              binary="true"
            ></p-checkbox>
            <p-checkbox
              *ngIf="!verDetalle"
              label="{{ 'SARLAFT.LBL_HABILITADO' | translate }}"
              id="indicadorHabilitado"
              name="nomindicadorHabilitado"
              formControlName="indicadorHabilitado"
              binary="true"
            ></p-checkbox>
          </div>
        </div>
      </div>

      <div class="grid" *ngIf="!verDetalle">
        <div class="form-group col-12">
          <div *ngIf="!guardando" style="display: flex;justify-content: center;align-items: center">
            <a (click)="regresar(formulario.dirty)" class="cancelar">{{
              "BTN_CANCELAR" | translate
            }}</a>
            <button
              icon="fa fa-floppy-o"
              label="{{ 'BTN_GUARDAR' | translate }}"
              type="submit"
              pButton
            ></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
            <span>{{ "LBL_GUARDANDO" | translate }}</span>
          </div>
        </div>
      </div>
    </form>
  </p-accordionTab>
  <p-accordionTab
    header="{{ 'SARLAFT.LBL_CONDICIONES' | translate }}"
    [disabled]="conDisabled"
    [selected]="tabCondiciones"
  >
    <app-sarlaft-variables-condiciones *ngIf="!conDisabled"
      [variable]="variable" [verDetalle]="verDetalle"
    ></app-sarlaft-variables-condiciones>
  </p-accordionTab>
  <div
    class="grid form-footer-buttons"
  >
    <div class="form-group col-12">
      <button
        icon="fa fa-arrow-left"
        label="{{ 'BTN_REGRESAR' | translate }}"
        type="button"
        pButton
        (click)="regresar(false)"
      ></button>
    </div>
  </div>
</p-accordion>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
